<template>
    <div class="legal-container container mx-auto p-6 max-w-4xl bg-white shadow-md rounded-lg">
        <h2 class="text-xl font-semibold mb-4">{{ $translate('Cookies Policy') }}</h2>
        <div v-if="loading" class="text-center">
            {{ $translate('Loading, please wait...') }}
        </div>
        <div v-else-if="content">
            <p v-html="content"></p>
        </div>
        <div v-else class="text-red-500">
            {{ $translate('Failed to load content.') }}
        </div>
    </div>
</template>

<script>

export default {
    name: 'CookiePolicyPage',
    data() {
        return {
            content: null, // Holds the fetched content
            loading: true, // Indicates if data is being loaded
        };
    },
    mounted() {
        this.fetchLegalPage();
    },
    methods: {
        async fetchLegalPage() {
            try {
                const response = await fetch('https://webwire.cz/api/v2/brand/legal-pages', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({
                        brand_id: window.vueAppConfig.info.id, // Adjust the brand slug as needed
                        page: 'cookie', // Fetching the privacy page
                    }),
                });

                const data = await response.json();

                if (data.status) {
                    // Assuming 'data' contains the actual legal page content in 'data.data'
                    if (data.data) {
                        this.content = data.data;
                    } else {
                        this.loading = false;
                    }
                } else {
                    console.error('Failed to fetch legal page:', data.message);
                }
            } catch (error) {
                console.error('Fetch legal page failed:', error);
            } finally {
                this.loading = false;
            }
        },
    },
};
</script>

<style>
.legal-container {
    font-family: sans-serif;
    color: #333;
    line-height: 1.6;
}

/* Reusable spacing variables */
:root {
    --spacing-lg: 1.5rem;
    --spacing-md: 1rem;
    --spacing-sm: 0.5rem;
    --text-color-link: #007bff;
}

/* Paragraph styling */
.legal-container p {
    text-align: justify;
    margin-bottom: var(--spacing-md);
}

/* Lists */
.legal-container ul,
.legal-container ol {
    margin: var(--spacing-md) var(--spacing-lg);
    padding-left: 1.5rem;
    list-style: square;

}

.legal-container li {
    margin-bottom: var(--spacing-sm);
    line-height: 1.4;

}

/* Links */
.legal-container a {
    color: var(--text-color-link);
    text-decoration: underline;
}

.legal-container a:hover {
    color: darken(var(--text-color-link), 10%);
    text-decoration: none;
}

/* Headings styling */
.legal-container h1,
.legal-container h2,
.legal-container h3,
.legal-container h4,
.legal-container h5,
.legal-container h6 {
    font-weight: bold;
    margin-bottom: var(--spacing-md);
    margin-top: var(--spacing-lg);
}

/* Font size adjustments for headings */
.legal-container h1 {
    font-size: 1.75rem;
}

.legal-container h2 {
    font-size: 1.5rem;
}

.legal-container h3 {
    font-size: 1.25rem;
}

.legal-container h4 {
    font-size: 1.125rem;
}

.legal-container h5 {
    font-size: 1rem;
}

.legal-container h6 {
    font-size: 0.875rem;
}

/* Responsive improvements for smaller screens */
@media (max-width: 640px) {
    .legal-container {
        padding: var(--spacing-sm);
    }

    .legal-container h1 {
        font-size: 1.5rem;
    }

    .legal-container h2 {
        font-size: 1.25rem;
    }

    .legal-container h3 {
        font-size: 1.125rem;
    }

    .legal-container h4,
    .legal-container h5,
    .legal-container h6 {
        font-size: 1rem;
    }
}
</style>